import { render, staticRenderFns } from "./EventRejectConfirm.vue?vue&type=template&id=1d283644&"
import script from "./EventRejectConfirm.vue?vue&type=script&lang=js&"
export * from "./EventRejectConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports